import {
  IFormCreateEditType, IMailHistoryData, IMailMagazine, IRequestTemporarySave, KEY_TYPE, OptionType,
} from 'pages/mailMagazine/type';
import { MailMagazineCreateEditType } from './index';

export const types = {
  SET_INITIAL_DATA: 'SET_INITIAL_DATA' as const,
  SET_CONFIRM_DATA: 'SET_CONFIRM_DATA' as const,
  FETCH_DATA_START: 'FETCH_DATA_START' as const,
  FETCH_DATA_ERROR: 'FETCH_DATA_ERROR' as const,
  CLEAR_DATA: 'CLEAR_DATA' as const,
  TEMPORARY_SAVE: 'TEMPORARY_SAVE' as const,
  FETCH_DATA_END: 'FETCH_DATA_END' as const,
  RELOAD_DETAIL_DATA: 'RELOAD_DETAIL_DATA' as const,
};
export const setDataComeMagazineList = (data: (IMailMagazine | null),
  valueMenuItemOptionsState:Map<KEY_TYPE, OptionType[]>,
  isComeFromHistory: boolean) => ({
  type: types.SET_INITIAL_DATA,
  payload: {
    valueMenuItemOptionsState,
    data,
    isComeFromHistory,
  },
});

export const reloadDetailData = (data: (IMailMagazine | null)) => ({
  type: types.RELOAD_DETAIL_DATA,
  payload: data,
});
export const fetchDataEnd = () => ({
  type: types.FETCH_DATA_END,
});
export const setTemporarySave = (request:IRequestTemporarySave) => ({
  type: types.TEMPORARY_SAVE,
  payload: request,
});
export const setConfirmDataMagazineDetail = (form:MailMagazineCreateEditType, mailMagazineSendCustomer:string[]) => (
  {
    type: types.SET_CONFIRM_DATA,
    payload: {
      formData: form,
      mailMagazineSendCustomer,
    },
  }
);

export const fetchDataStart = () => ({
  type: types.FETCH_DATA_START,
});

export const fetchDataError = (error:string) => ({
  type: types.FETCH_DATA_ERROR,
  payload: error,
});

export const clearData = () => ({
  type: types.CLEAR_DATA,
});
export type Actions = (
    | ReturnType<typeof setDataComeMagazineList>
    | ReturnType<typeof setConfirmDataMagazineDetail>
    | ReturnType<typeof fetchDataError>
    | ReturnType<typeof fetchDataStart>
    | ReturnType<typeof clearData>
    | ReturnType<typeof setTemporarySave>
    | ReturnType<typeof fetchDataEnd>
    | ReturnType<typeof reloadDetailData>
  );
